import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTheme } from '../../context/ThemeContext'
import useVersioning from '../../hooks/useVersioning'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import {  doc, onSnapshot } from 'firebase/firestore'
import { db } from '../../../index'
import { createSafeHtml } from '../../utils/htmlSanitizer'
import './VersionUpdateModal.css'

type Props = {
  reload:boolean
  setReload: React.Dispatch<React.SetStateAction<boolean>>
}
const Version:React.FC<Props> =({reload,setReload})=>{
const { theme } = useTheme()

   const [content, setContent] = useState<string>("");
  useEffect(() => {
      const unsubscribe = onSnapshot(doc(db, "versioning", `b4igo-dev`), (docSnap) => {



      if (docSnap.exists()) {
        setContent(JSON.parse(`"${docSnap.data().content}"`));
      }
    });
    return () => unsubscribe();

  }, []);



  return (
    <Modal
      contentClassName={theme === 'dark' ? 'layout__theme__div' : ''}
      show={reload}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      scrollable
    >
      <Modal.Header>
        <Modal.Title>
          <h1 className={theme === 'dark' ? 'white__text' : ''}>New Update!</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex justify-content-start align-items-center flex-column position-relative'>
          <div className='fs-2'>New updates of the app is available. Please refresh the page.</div>
          <div dangerouslySetInnerHTML={createSafeHtml(content, 'default')} />
          <div className='my-5 w-50 version-modal-container'>
          <div className="d-flex position-absolute justify-content-center align-items-center mb-5 gap-1 cursor-pointer version-modal-click-area" onClick={() => {
            setReload(false)
            window.location.reload()
          }}>
            <img className="w-25" src={toAbsoluteUrl('/media/logos/orange-robot-bold.svg')} />
              <span className="w-100 break-word version-modal-orange-text">Click on me to close this window and load the new features.</span>
          </div>
        </div>
        </div>
      </Modal.Body>
    </Modal >
  )
}

const VersionUpdateModal: React.FC = () => {
  
  const { reload,setReload } = useVersioning()



  return (
    <>
    {
      reload &&
      <Version setReload={setReload} reload={reload}/>
    }
    </>
  )
}

export default VersionUpdateModal